exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "label[data-v-bdf60378]{display:block;margin:10px 0}label span[data-v-bdf60378]{display:inline-block;width:110px}label input[data-v-bdf60378]{vertical-align:middle}.error[data-v-bdf60378]{font-weight:bold;color:#c00}\n", ""]);

